<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8418 4.57533V5.19199L11.8918 3.48366C10.7751 2.84199 9.21678 2.84199 8.10845 3.48366L5.15845 5.20033V4.57533C5.15845 2.70033 6.18345 1.66699 8.05845 1.66699H11.9418C13.8168 1.66699 14.8418 2.70033 14.8418 4.57533Z"
      fill="#292D32"
    />
    <path
      d="M14.8667 6.64186L14.7501 6.58353L13.6167 5.93353L11.2667 4.5752C10.5501 4.15853 9.45008 4.15853 8.73341 4.5752L6.38341 5.9252L5.25008 6.59186L5.10008 6.66686C3.64175 7.6502 3.54175 7.83353 3.54175 9.40853V13.1752C3.54175 14.7502 3.64175 14.9335 5.13341 15.9419L8.73341 18.0169C9.09175 18.2335 9.54175 18.3252 10.0001 18.3252C10.4501 18.3252 10.9084 18.2252 11.2667 18.0169L14.9001 15.9169C16.3667 14.9335 16.4584 14.7585 16.4584 13.1752V9.40853C16.4584 7.83353 16.3584 7.6502 14.8667 6.64186ZM12.3251 11.2502L11.8167 11.8752C11.7334 11.9669 11.6751 12.1419 11.6834 12.2669L11.7334 13.0669C11.7667 13.5585 11.4167 13.8085 10.9584 13.6335L10.2167 13.3335C10.1001 13.2919 9.90842 13.2919 9.79175 13.3335L9.05008 13.6252C8.59175 13.8085 8.24175 13.5502 8.27508 13.0585L8.32508 12.2585C8.33341 12.1335 8.27508 11.9585 8.19175 11.8669L7.67508 11.2502C7.35841 10.8752 7.50008 10.4585 7.97508 10.3335L8.75008 10.1335C8.87508 10.1002 9.01675 9.98353 9.08341 9.88353L9.51675 9.21686C9.78342 8.8002 10.2084 8.8002 10.4834 9.21686L10.9167 9.88353C10.9834 9.99186 11.1334 10.1002 11.2501 10.1335L12.0251 10.3335C12.5001 10.4585 12.6417 10.8752 12.3251 11.2502Z"
      fill="#292D32"
    />
  </svg>
</template>
  
<script>
export default {
  name: "AchievementsActiveIcon",
  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    isActive: Boolean,
  },
  data() {
    return {};
  },
};
</script>
